import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useForm } from 'react-hook-form';
import RHFAutocomplete from '#component/form/rhf/rhf-autocomplete';
import {
  FormCnt,
  StyledPaper,
  ButtonCnt,
  StyledButton
} from './styles';

const Form = props => {
  const {
    onSubmit,
    handleCloseDialog,
    initialValues
  } = props;
  const { addressbooks, status } = useSelector(s => s.addressbooks, shallowEqual);

  const { control, handleSubmit, reset } = useForm({
    defaultValues: initialValues || {}
  });

  useEffect(() => {
    if (initialValues) {
      reset(initialValues);
    }
  }, [initialValues, reset]);

  return (
    <FormCnt autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <StyledPaper>
        <RHFAutocomplete
          name="addressbook"
          control={control}
          loading={status === 'loading'}
          options={addressbooks}
          getOptionLabel={option => (typeof option === 'string' ? option : option?.label || '')}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          fullWidth
          inputProps={{ label: 'Address book', variant: 'outlined' }}
        />
      </StyledPaper>
      <ButtonCnt>
        <StyledButton
          variant="outlined"
          onClick={handleCloseDialog}
        >
          Cancel
        </StyledButton>
        <StyledButton
          type="submit"
          variant="contained"
          color="secondary"
        >
          Save
        </StyledButton>
      </ButtonCnt>
    </FormCnt>
  );
};

export default Form;
